import { forwardRef, type SVGProps } from 'react';

export const SettledIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  function SettledIcon(props, ref) {
    return (
      <svg
        ref={ref}
        fill="none"
        viewBox="0 0 26 26"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#settled_svg__a)">
          <path
            clipRule="evenodd"
            d="m3 22 1.5-1.5L6 22l1.5-1.5L9 22l1.183-1.183a9.05 9.05 0 0 1 .04-3.817H6v-2h4.935c.362-.728.82-1.4 1.357-2H6v-2h8.873c1.236-.64 2.64-1 4.127-1 .687 0 1.357.077 2 .223V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2zM6 9V7h12v2zm11.225 9.825L18.3 19.9l2.475-2.475a.47.47 0 0 1 .35-.137q.212 0 .35.137a.47.47 0 0 1 .137.35.47.47 0 0 1-.137.35L18.65 20.95a.48.48 0 0 1-.7 0l-1.425-1.425a.47.47 0 0 1-.137-.35q0-.212.137-.35a.47.47 0 0 1 .35-.137q.212 0 .35.137m-.175 4.781A4.9 4.9 0 0 0 19 24a4.9 4.9 0 0 0 1.95-.393 5.1 5.1 0 0 0 1.588-1.07q.674-.675 1.068-1.587A4.9 4.9 0 0 0 24 19a4.9 4.9 0 0 0-.393-1.95 5.1 5.1 0 0 0-1.07-1.588q-.675-.674-1.587-1.068A4.9 4.9 0 0 0 19 14q-1.038 0-1.95.394a5 5 0 0 0-1.588 1.069q-.674.675-1.068 1.587A4.9 4.9 0 0 0 14 19q0 1.038.394 1.95a5 5 0 0 0 1.069 1.588q.675.674 1.587 1.068"
            fill="currentColor"
            fillRule="evenodd"
          />
        </g>
        <defs>
          <clipPath id="settled_svg__a">
            <path d="M0 0h24v24H0z" fill="#fff" />
          </clipPath>
        </defs>{' '}
      </svg>
    );
  },
);
